window.addEventListener('load', () => {
    const form = document.querySelector('#NVAdvocacyForm1221979');
    if (form) {
        const everyActionFormSubmitBtn = form.getElementsByClassName('at-submit')[0];
        everyActionFormSubmitBtn.addEventListener('click', () => {
            document.getElementById("NVAdvocacyForm1221979").scrollIntoView({block: "center", behavior: "smooth"});
        });
    }
});
